class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.submenu = this.querySelector('.header__submenu');

    this.submenuLinks = this.querySelectorAll('[data-header-submenu-link]');
    this.submenuLinks.forEach((submenuLink) => {
      submenuLink.addEventListener('click', (event) => {
        let target = event.target;
        let index = target.dataset.headerSubmenuLink;
        let parent = target.closest('.header__submenu-title');
        let tabs = parent.nextElementSibling;
        let tab = tabs.querySelector('[data-header-submenu-tab="'+index+'"]');
        parent.querySelectorAll('[data-header-submenu-link]').forEach((el) => {el.classList.remove('active')});
        tabs.querySelectorAll('[data-header-submenu-tab]').forEach((el) => {el.classList.remove('active')});
        target.classList.add('active');
        tab.classList.add('active');
      });
    });
    this.mainDetailsToggle.addEventListener('mousemove', (event) => {
      if (this.submenu) {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      }
    });
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
